var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.5717 51.959L22.8245 36.6207L9.15332 34.3903C10.4624 33.631 54.8468 12.583 54.8468 12.583L45.7175 46.0068L32.2106 38.91L25.5717 51.959Z","stroke":"currentColor","strokeWidth":"2","strokeLinejoin":"round"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 65"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
